import { LeadByIndicator } from '../../../components/LeadByIndicator'
import { TContactPersonsProps } from './types'
import { useCognusRepositoryPopup } from '../Providers/CognusRepositoryPopupProvider'

export const ContactPersons = (props: TContactPersonsProps) => {
  const { contactPersonsPopup } = useCognusRepositoryPopup()
  const { actions } = contactPersonsPopup
  const { led_by } = props

  return (
    <LeadByIndicator
      value={led_by}
      onClick={() => actions.open({ ...props })}
    />
  )
}
